<script setup>
/* global axios */
import { ref, onMounted, h, render } from 'vue';
import { useStore } from 'vuex';
import CentertelTeamSelectModal from './CentertelTeamSelectModal.vue';

const store = useStore();

const showModal = ref(false);
const modalTeams = ref([]);
const modalAgentName = ref('');
let pendingAssign = null;

onMounted(() => {
  // Interceptar assignAgent — sobrescrever a action do store
  const originalAssignAgent = store._actions['assignAgent']?.[0];
  if (!originalAssignAgent) return;

  store._actions['assignAgent'] = [async (payload) => {
    const { agentId, conversationId } = payload;
    if (!agentId) {
      // Desatribuindo agente — chamar original
      return originalAssignAgent(payload);
    }

    try {
      const accountId = store.getters.getCurrentAccountId;
      const { data: teams } = await axios.get(
        `/api/v1/accounts/${accountId}/agents/${agentId}/teams`
      );

      // Buscar conversa atual para ver o time
      const conversation = store.getters['getConversationById'](conversationId);
      const currentTeamId = conversation?.meta?.team?.id;

      if (teams.length <= 1 || teams.some(t => t.id === currentTeamId)) {
        // 0-1 time ou já está no time certo — callback backend resolve
        return originalAssignAgent(payload);
      }

      // Múltiplos times — mostrar popup
      const agents = store.getters['agents/getAgents'] || [];
      const agent = agents.find(a => a.id === agentId);
      modalAgentName.value = agent?.name || 'Agente';
      modalTeams.value = teams;
      pendingAssign = { payload, originalAssignAgent };
      showModal.value = true;
    } catch {
      // Erro — chamar original sem popup
      return originalAssignAgent(payload);
    }
  }];
});

const onTeamSelect = async (teamId) => {
  showModal.value = false;
  if (!pendingAssign) return;

  const { payload, originalAssignAgent } = pendingAssign;
  pendingAssign = null;

  // Atribuir agente
  await originalAssignAgent(payload);

  // Mudar time
  const { conversationId } = payload;
  await store.dispatch('assignTeam', { conversationId, teamId });
};

const onCancel = () => {
  showModal.value = false;
  pendingAssign = null;
};
</script>

<template>
  <CentertelTeamSelectModal
    :show="showModal"
    :teams="modalTeams"
    :agent-name="modalAgentName"
    @select="onTeamSelect"
    @cancel="onCancel"
  />
</template>
